import type { SearchTableQuery } from "owa-mail-list-search";
import { type TableQueryType } from "owa-mail-list-store";
import { getScenarioStore, SearchScenarioId } from "owa-search-store";

type SearchFocusTableView = {
    tableQuery: {
        type: TableQueryType;
        scenarioType?: SearchTableQuery["scenarioType"];
    };
};

export default function shouldPreserveSearchInputFocus(tableView?: SearchFocusTableView): boolean {
    const searchStore = getScenarioStore(SearchScenarioId.Mail);
    if (!searchStore.searchBoxHasFocus) {
        return false;
    }
    
    const isQueryOnTypeTable = tableView?.tableQuery.type === 1 &&
        tableView.tableQuery.scenarioType === "queryOnType";
    const isRestoredTableForEmptySearch = !!tableView &&
        tableView.tableQuery.type !== 1 &&
        !!searchStore.searchSessionGuid &&
        !searchStore.searchText.trim() &&
        !searchStore.searchTextForSuggestion.trim();
    
    return isQueryOnTypeTable || isRestoredTableForEmptySearch;
}
